import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["county", "township", "community"]

  connect() {
    this.syncOptions()
  }

  countyChanged(event) {
    event.stopPropagation()
    this.syncOptions()
    this.submitForm()
  }

  townshipChanged(event) {
    event.stopPropagation()
    this.syncCommunities()
    this.submitForm()
  }

  syncOptions() {
    this.syncTownships()
    this.syncCommunities()
  }

  syncTownships() {
    const county = this.countyValue

    this.townshipOptions.forEach((option) => {
      if (option.value === "") return

      const matchesCounty = county === "" || option.dataset.county === county
      option.hidden = !matchesCounty
      option.disabled = !matchesCounty
    })

    if (!this.selectedTownshipVisible) {
      this.townshipTarget.value = ""
    }

    this.refreshSelect(this.townshipTarget)
  }

  syncCommunities() {
    const county = this.countyValue
    const townshipId = this.townshipTarget.value

    this.communityOptions.forEach((option) => {
      if (option.value === "") return

      const townshipIds = option.dataset.townshipIds.split(",").filter(Boolean)
      const countyValues = option.dataset.counties.split(",").filter(Boolean)
      const matchesCounty = county === "" || countyValues.includes(county)
      const matchesTownship = townshipId === "" || townshipIds.includes(townshipId)
      const visible = matchesCounty && matchesTownship

      option.hidden = !visible
      option.disabled = !visible
    })

    if (!this.selectedCommunityVisible) {
      this.communityTarget.value = ""
    }

    this.refreshSelect(this.communityTarget)
  }

  refreshSelect(select) {
    if (window.jQuery?.fn?.select2) {
      window.jQuery(select).trigger("change.select2")
    } else {
      select.dispatchEvent(new Event("change"))
    }
  }

  submitForm() {
    this.element.requestSubmit()
  }

  get countyValue() {
    return this.countyTarget.value
  }

  get townshipOptions() {
    return this.townshipTarget.querySelectorAll("option[data-county]")
  }

  get communityOptions() {
    return this.communityTarget.querySelectorAll("option[data-township-ids]")
  }

  get selectedTownshipVisible() {
    const selectedOption = this.townshipTarget.selectedOptions[0]
    return !selectedOption || selectedOption.value === "" || !selectedOption.hidden
  }

  get selectedCommunityVisible() {
    const selectedOption = this.communityTarget.selectedOptions[0]
    return !selectedOption || selectedOption.value === "" || !selectedOption.hidden
  }
}
